export const permissonsByRoles = {
    user: ["Admin"],
    users: ["Admin"],
    business: ["Admin"],
    businesses: ["Admin"],
    region: ["Admin"],
    regions: ["Admin"],
    logo: ["Admin"],
    logos: ["Admin"],
    "teste-tiny-editor": ["Admin"],
    "teste-monaco-editor": ["Admin"],
    "teste-document-buider": ["Admin"],
    "table-styles": ["Admin"],
    "list-styles": ["Admin"],
    "text-styles": ["Admin"],
    "table-style": ["Admin"],
    "list-style": ["Admin"],
    "text-style": ["Admin"],
    template: ["Admin"],
    templates: ["Admin"],
    section: ["Admin", "Author", "Reviewer", "Publisher"],
    sections: ["Admin", "Author", "Reviewer", "Publisher"],
    snippets: ["Admin", "Author", "Reviewer", "Publisher"],
    snippet: ["Admin", "Author", "Reviewer", "Publisher"],
    document: ["Admin", "Author", "Reviewer", "Publisher"],
    documents: ["Admin", "Author", "Reviewer", "Publisher"],
    "bulk-actions": ["BulkSubmitter", "BulkReviewer", "BulkPublisher", "BulkObsoleter"],
  };